'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);

var useBooleanState = function (initialState) {
    if (initialState === void 0) { initialState = false; }
    var _a = tslib_es6.__read(React.useState(initialState), 2), value = _a[0], setValue = _a[1];
    return {
        value: value,
        toggle: React.useCallback(function () { return setValue(function (prevState) { return !prevState; }); }, [setValue]),
        setTrue: React.useCallback(function () { return setValue(true); }, [setValue]),
        setFalse: React.useCallback(function () { return setValue(false); }, [setValue]),
    };
};

exports.useBooleanState = useBooleanState;
